import type { VizProps } from "./registry.js";

/**
 * Inline table from a JSON array of rows. Placeholder shape; extend to
 * accept column config, sorting, etc.
 */
export function TableViz({ source }: VizProps) {
  let rows: Record<string, unknown>[] = [];
  let parseError: string | null = null;
  try {
    const parsed = JSON.parse(source);
    if (Array.isArray(parsed)) rows = parsed as Record<string, unknown>[];
    else parseError = "expected a JSON array of row objects";
  } catch (e) {
    parseError = e instanceof Error ? e.message : String(e);
  }
  if (parseError) {
    return (
      <pre className="dw-error">table: {parseError}</pre>
    );
  }
  if (!rows.length) return <div className="dw-empty">No rows.</div>;
  const cols = Object.keys(rows[0]);
  return (
    <div className="dw-table-wrap">
      <table className="dw-table">
        <thead>
          <tr>
            {cols.map((c) => (
              <th key={c}>{c}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i}>
              {cols.map((c) => (
                <td key={c}>
                  {row[c] === null || row[c] === undefined
                    ? ""
                    : String(row[c])}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
